"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getEwsRequestDateString_1 = require("./utils/getEwsRequestDateString");
var applyConversationActionRequest_1 = require("owa-service/lib/factory/applyConversationActionRequest");
var conversationAction_1 = require("owa-service/lib/factory/conversationAction");
var folderId_1 = require("owa-service/lib/factory/folderId");
var itemId_1 = require("owa-service/lib/factory/itemId");
var targetFolderId_1 = require("owa-service/lib/factory/targetFolderId");
var applyConversationActionOperation_1 = require("owa-service/lib/operation/applyConversationActionOperation");
var ServiceRequestUtils_1 = require("owa-service/lib/ServiceRequestUtils");
/**
 * Create a ConversationAction with move params for a given conversation.
 * @param conversationContext the conversation context to be moved
 * @param currentFolderTargetId - the table view the conversations are moving from (null for search)
 * @param destinationFolderTargetId - the folder they need to go to
 */
function createMoveConversationAction(conversationContext, currentFolderTargetId, destinationFolderTargetId) {
    return conversationAction_1.default({
        Action: 'Move',
        ConversationId: itemId_1.default({ Id: conversationContext.conversationId }),
        ContextFolderId: currentFolderTargetId,
        DestinationFolderId: destinationFolderTargetId,
        ConversationLastSyncTime: getEwsRequestDateString_1.default(conversationContext.conversationLastSyncTimeStamp),
    });
}
/**
 * Worker method which converts the provided data into an ApplyConversationActionRequest.
 * @param conversationContexts the conversation contexts to be moved
 * @param destinationFolderId - the folder they need to move to
 * @param currentFolderId - the folder they originate in -- null for search scenarios
 * @returns an ApplyConversationActionRequest
 */
function configureRequestBody(conversationContexts, destinationFolderId, currentFolderId) {
    var destinationFolderTargetId = targetFolderId_1.default({
        BaseFolderId: folderId_1.default({ Id: destinationFolderId }),
    });
    // This is a workaround for the fact that in search scenarios we need to pass a completely null ContextFolderId
    // (not the BaseFolderId form in the false condition of the ternary) in all conversationActions.
    var currentFolderTargetId = currentFolderId == null
        ? null
        : targetFolderId_1.default({ BaseFolderId: folderId_1.default({ Id: currentFolderId }) });
    var conversationActions = conversationContexts.map(function (conversationContext) {
        return createMoveConversationAction(conversationContext, currentFolderTargetId, destinationFolderTargetId);
    });
    return applyConversationActionRequest_1.default({
        ConversationActions: conversationActions,
        ReturnMovedItemIds: true,
    });
}
/**
 * The service which calls the ApplyConversationAction with move parameters.
 * @param conversationContexts the conversation contexts to be moved
 * @param destinationFolderId - the folder they need to move to
 * @param currentFolderId - the folder they originate in -- null for search scenarios
 */
function moveConversationService(conversationContexts, destinationFolderId, currentFolderId) {
    var requestBody = configureRequestBody(conversationContexts, destinationFolderId, currentFolderId);
    return applyConversationActionOperation_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
exports.default = moveConversationService;
//# sourceMappingURL=moveConversationService.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-store/lib/services/moveConversationService.js
// module id = 5600
// module chunks = 62